@if (showIframe) {
  <iframe
    [ngClass]="{'displayIframe': displayIframe()}"
    [srcdoc]="iframeHTML | safe: 'html'"
    allow="microphone *; camera *;"
    frameborder="0"
    >
  </iframe>
}
@if (!showIframe && !iframeHTML) {
  <div  fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
    @if (!showIframe && !iframeHTML && !showLtiError) {
      <div><mat-spinner></mat-spinner></div>
    }
    @if (showLtiError) {
      <div style="margin:16px">Failed to connect to Resource.</div>
    }
  </div>
}
